/* Carry the storefront language through existing requests. Never grant consent. */
(function(root){
 'use strict';
 const languages=['fr','en','de','es','fi','hu','it','nl','pl','sv'];
 function language(value){const code=String(value||'fr').toLowerCase().split(/[-_]/)[0];return languages.includes(code)?code:'fr';}
 function enrich(url,body,locale,storefrontRoot='/'){
  let u;try{u=new URL(url,'https://solsticebijoux.com');}catch{return body;}
  if(typeof body!=='string')return body;
  const client=u.origin==='https://a.klaviyo.com'&&u.pathname.startsWith('/client/')&&u.searchParams.get('company_id')==='TD6BVa';
  const lead=u.origin==='https://ear-configurator-backend-production.up.railway.app'&&u.pathname==='/api/save-lead';
  if(!client&&!lead)return body;
  let data;try{data=JSON.parse(body);}catch{return body;}
  const code=language(locale);
  if(lead){data.locale=code;data.storefront_root=storefrontRoot;return JSON.stringify(data);}
  const profile=data?.data?.type==='profile'?data.data:data?.data?.attributes?.profile?.data;
  if(!profile?.attributes)return body;
  profile.attributes.locale=code;
  profile.attributes.properties={...profile.attributes.properties,solstice_language:code,solstice_storefront_root:storefrontRoot,solstice_language_source:'storefront'};
  if(data.data.type==='event')data.data.attributes.properties={...data.data.attributes.properties,locale:code};
  return JSON.stringify(data);
 }
 if(typeof module!=='undefined'&&module.exports)module.exports={language,enrich};
 if(!root?.document||!root.fetch)return;
 const locale=()=>language(root.document.documentElement.lang);
 const storefront=()=>root.Shopify?.routes?.root||'/';
 const original=root.fetch;
 root.fetch=function(input,init){
  const url=typeof input==='string'?input:input?.url;
  if(init&&typeof init.body==='string'){
   const body=enrich(url,init.body,locale(),storefront());
   if(body!==init.body)init={...init,body};
  }
  if(root.Request&&input instanceof root.Request&&!init?.body&&input.method==='POST'&&/a\.klaviyo\.com\/client\//.test(url)){
   return input.clone().text().then(body=>{
    const updated=enrich(url,body,locale(),storefront());
    return original.call(this,updated===body?input:new root.Request(input,{body:updated}),init);
   });
  }
  return original.call(this,input,init);
 };
 // Klaviyo embeds may use XHR while custom forms use fetch. Retain the same response,
 // callbacks, headers, timing and channel subscription fields in both transports.
 if(root.XMLHttpRequest){
  const open=root.XMLHttpRequest.prototype.open,send=root.XMLHttpRequest.prototype.send;
  const urls=new WeakMap();
  root.XMLHttpRequest.prototype.open=function(method,url,...args){urls.set(this,url);return open.call(this,method,url,...args);};
  root.XMLHttpRequest.prototype.send=function(body){return send.call(this,enrich(urls.get(this),body,locale(),storefront()));};
 }
 async function syncKnown(){
  if(!root.Shopify?.customerPrivacy?.marketingAllowed?.()||!root.klaviyo?.isIdentified||!root.klaviyo?.identify)return;
  try{if(await root.klaviyo.isIdentified())await root.klaviyo.identify({$locale:locale(),solstice_language:locale(),solstice_storefront_root:storefront(),solstice_language_source:'storefront'});}catch{/* Shopping must never wait on tracking. */}
 }
 root.addEventListener('klaviyoForms',event=>{if(['submit','stepSubmit'].includes(event.detail?.type))syncKnown();});
 root.document.addEventListener('visitorConsentCollected',syncKnown);
 root.addEventListener('pageshow',syncKnown);
 root.setTimeout(syncKnown,8000);
})(typeof window==='undefined'?null:window);
